/* not autogenerated because string.length validation does not work*/
/* eslint-disable no-multiple-empty-lines */
import * as React from "react";
import { connect } from "react-redux";

import { Form } from "semantic-ui-react";
import { EditComponent, SaveDispatchProps, EditProps as SharedEditProps } from "@neworbit/simpleui-forms";
import { Input } from "@neworbit/simpleui-input";

import { ThunkDispatch } from "redux-thunk";

import { TaskCodeEditModel, AppState, TASK_TYPE_OPTIONS } from "../model";
import { taskCodeSelector, basePathSelector } from "../selectors";
import { saveTaskCode } from "../actions";

import { EditModal } from "./EditModal";

import { push } from "redux-little-router";


export interface EditProps extends SharedEditProps<TaskCodeEditModel> {
    open: boolean;
}

export interface DispatchProps extends SaveDispatchProps<TaskCodeEditModel> {
    close: () => void;
}

export class Edit extends EditComponent<TaskCodeEditModel, EditProps> {

    public render() {
        return (
            <Form onSubmit={this.handleSubmit}>

                <Input.Text
                    value={this.state.values.name}
                    label="Name"
                    showErrors={this.state.showErrors}
                    required
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("name", value, valid)}
                />

                <Input.Dropdown
                    label="Task Type *"
                    placeholder="Please select"
                    showErrors={this.state.showErrors}
                    required
                    search
                    value={this.state.values.taskType}
                    options={TASK_TYPE_OPTIONS}
                    // eslint-disable-next-line react/jsx-no-bind
                    onChange={(value, valid) => this.updateProperty("taskType", value, valid)}
                />

            </Form>
        );
    }

    public submit(): void {
        this.handleSubmit({ preventDefault: (): void => undefined } as any);
    }
}

function mapStateToProps(state: AppState) {
    return {
        model: taskCodeSelector(state) as TaskCodeEditModel,
        open: state.router.pathname.endsWith("/edit"),
        basePath: basePathSelector(state)
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<AppState, undefined, any>) {
    return {
        dispatchSave: (taskCode: TaskCodeEditModel, basePath: string) => dispatch(saveTaskCode(taskCode, basePath)),
        dispatchClose: (basePath: string) => dispatch(push(basePath, {}))
    };
}

function mergeProps(propsFromState: any, propsFromDispatch: any): EditProps & DispatchProps {
    return {
        model: propsFromState.model,
        open: propsFromState.open,
        save: (taskCode: TaskCodeEditModel) => propsFromDispatch.dispatchSave(taskCode, propsFromState.basePath),
        close: () => propsFromDispatch.dispatchClose(`${propsFromState.basePath}/${propsFromState.model.id}`)
    };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(EditModal);
